import {
  ContainerMain,
  matchContainerPadding,
} from '@components/Container/index.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import { Heading1 } from '@styles/vars/textStyles.style'
import styled from 'styled-components'

export const HeroMain = styled.div`
  position: relative;
  text-align: center;
  background-color: ${colors.yellow};

  ${ContainerMain} {
    position: relative;
  }

  ${Heading1} {
    position: relative;
    z-index: 1;
  }
`

export const HeroImageA = styled.div`
  position: absolute;
  top: 18%;
  ${matchContainerPadding('left')}
  transform: translateY(0%);
  width: 25%;
  max-width: 35rem;

  ${mq.mobileL} {
    top: 50%;
    transform: translateY(-50%);
  }
`

export const HeroImageB = styled.div`
  position: absolute;
  bottom: 4%;
  ${matchContainerPadding('right')}
  transform: translateY(0%);
  width: 25%;
  max-width: 35rem;

  ${mq.mobileL} {
    top: 50%;
    bottom: auto;
    transform: translateY(-50%);
  }
`
